import React from 'react';
import { IfmsRoute }from '../../../config/types';

const MemoList = React.lazy(() => import('../MemoList'));

const routes:Array<IfmsRoute> = [
  {path: '/memoList/:viewIndex', component: MemoList},
];

export default routes;